import React, { FC } from 'react';
import LogoIcon from './styles';
import { Props } from './types';

const Logo: FC<Props> = ({ mode = 'normal', ...rest }) => (
  <LogoIcon mode={mode} {...rest} />
);

export default Logo;
